import { render, staticRenderFns } from "./PoliticaDSR.vue?vue&type=template&id=7b880874&"
import script from "./PoliticaDSR.vue?vue&type=script&lang=js&"
export * from "./PoliticaDSR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports